// SamostoyatelnayaRegistratsiyaShkoliFederatsii
import React, { useState, useEffect } from 'react';
import { Form, Input, Select } from 'antd';




const { Option } = Select;


export default function SamostoyatelnayaRegistratsiyaShkoliFederatsii(props) {
    const { auth, form } = props;
    const [regionalnieOtdeleniya, setRegionalnieOtdeleniya] = useState([]);
    const [city, setCity] = useState([]);
    const [regionID, setRegionID] = useState(0);

    useEffect(() => {
        auth.fetch('/api/query/City?s-name').then(res => {
            if (res && res.data) {
                setCity(res.data);
            }
        });
    }, []);

    useEffect(() => {
        auth.fetch('/api/query/RegionalnieOtdeleniya?s-nazvanie').then(res => {
            if (res && res.data) {
                setRegionalnieOtdeleniya(res.data);
            }
        });
    }, []);
 
    const options = regionalnieOtdeleniya.map(i => (
        <Option key={i.ID} value={i.ID}>{i.nazvanie}</Option>
    ));
    const optionsCity = city.filter((i) => i.regionID == regionID).map(i => (
        <Option key={i.ID} value={i.ID}>{i.name}</Option>
    ));

    const handleRegionChange = (value) => {
        var ro = regionalnieOtdeleniya.find((i) => i.ID === value);
        if (ro) {
            setRegionID(ro.regionID);
            form.setFieldsValue({
                gorodID: null,
            });
        }
    };

    // set_facebook varchar(250)
    // set_tik_tok varchar(250)
    // set_instagram varchar(250)
    // set_v_kontakte varchar(250)
    // sait varchar(1024)
    // e_mail varchar(100)
    // telefon varchar(50)
    // adres varchar(500)
    // gorod_stroka varchar(100)

    return (
        <Form
            form={props.form}
            onFinish={props.submit}
            labelAlign={"left"}
            layout={"vertical"}
            initialValues={{
                // neobkhodimiiKvorum: 50,
            }}
        >
            <Form.Item
                name={"nazvanie"}
                label={"Название"}
                rules={[{ required: true, message: 'Укажите название!' }]}
            >
                <Input />
            </Form.Item>
            <Form.Item
                name={"regionalnoeOtdelenieID"}
                label={"Региональное отделение"}
                rules={[{ required: true, message: 'Укажите региональное отделение!' }]}
            >
                <Select showSearch autoComplete="off" onChange={handleRegionChange}
                    filterOption={(input, option) =>
                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }>
                    {options}
                </Select>
            </Form.Item>
            <Form.Item
                name={"gorodID"}
                label={"Город"}
                rules={[{ required: false, message: 'Укажите город!' }]}
            >
                <Select showSearch autoComplete="off"
                    filterOption={(input, option) =>
                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }>
                    {optionsCity}
                </Select>
            </Form.Item>
            <Form.Item
                name={"gorodStroka"}
                label={"Город строка"}
                rules={[{ required: false, message: 'Укажите город строка!' },
                { max: 100, message: 'Значение должно быть не больше 100 символов!' }]}
            >
                <Input />
            </Form.Item>
            <Form.Item
                name={"adres"}
                label={"Адрес"}
                rules={[{ required: false, message: 'Укажите адрес!' },
                { max: 500, message: 'Значение должно быть не больше 500 символов!' }]}
            >
                <Input />
            </Form.Item>
            <Form.Item
                name={"telefon"}
                label={"Телефон"}
                rules={[{ required: false, message: 'Укажите телефон!' },
                { max: 50, message: 'Значение должно быть не больше 50 символов!' }]}
            >
                <Input />
            </Form.Item>
            <Form.Item
                name={"eMail"}
                label={"E-mail"}
                rules={[{ required: false, message: 'Укажите E-mail!' },
                { max: 100, message: 'Значение должно быть не больше 100 символов!' }]}
            >
                <Input />
            </Form.Item>
            <Form.Item
                name={"sait"}
                label={"Сайт"}
                rules={[{ required: false, message: 'Укажите сайт!' },
                        { max: 1024, message: 'Значение должно быть не больше 1024 символов!' }]}
            >
                <Input />
            </Form.Item>
            <Form.Item
                name={"setVKontakte"}
                label={"Сеть VK"}
                rules={[{ required: false, message: 'Укажите VK!' },
                { max: 250, message: 'Значение должно быть не больше 250 символов!' }]}
            >
                <Input />
            </Form.Item>
            <Form.Item
                name={"setInstagram"}
                label={"Сеть Instagram"}
                rules={[{ required: false, message: 'Укажите Instagram!' },
                { max: 250, message: 'Значение должно быть не больше 250 символов!' }]}
            >
                <Input />
            </Form.Item>
            <Form.Item
                name={"setTikTok"}
                label={"Сеть TikTok"}
                rules={[{ required: false, message: 'Укажите TikTok!' },
                { max: 250, message: 'Значение должно быть не больше 250 символов!' }]}
            >
                <Input />
            </Form.Item>
            <Form.Item
                name={"setFacebook"}
                label={"Сеть facebook"}
                rules={[{ required: false, message: 'Укажите Facebook!' },
                { max: 250, message: 'Значение должно быть не больше 250 символов!' }]}
            >
                <Input />
            </Form.Item>
        </Form>
    );
}
